<app-survey [userProfile]="userProfile" [surveyType]="'profile'"></app-survey>
